export class TwoFactorAuthFormProps {
    constructor(public username: string, public code: string = '') {}
}
